<template>

    <div class="container pdtb3">

        <header class="account-header">
            <img
                :class="{anon: !avatar_key}"
                :src="avatar_key ? 'https://rogerframpton.s3-eu-west-2.amazonaws.com/user-images/pi-' + avatar_key + '-' + user.id + '-large.png' : '/build/assets/account-anon.svg'"
                :alt="user.first_name + ' ' + user.last_name">

            <h1 class="standard-title m0">Your account</h1>
        </header>

        <div class="account-overview">

            <profile-image-component
                :avatar_key="avatar_key"
                :remove_processing="selectors_processing_status.remove_avatar"
                @done="newAvatarUploaded"
                @remove="removeAvatar"
            ></profile-image-component>

            <table>
                <tr v-if="usercoins">
                    <td><i class="fa fa-wallet"></i> Wallet balance</td>
                    <td><span class="coin-amount"><a href="/account/wallet-overview">{{ usercoins }}</a> <a href="/account/wallet-overview" class="small">view your transactions <fa class="fa fa-caret-right"></fa></a></span></td>
                </tr>
                <tr>
                    <td>Member since</td>
                    <td>{{ user.member_since }}</td>
                </tr>
                <tr>
                    <td>First name</td>
                    <td>{{ user.first_name }}</td>
                </tr>
                <tr>
                    <td>Last name</td>
                    <td>{{ user.last_name }}</td>
                </tr>
                <tr>
                    <td>Email address</td>
                    <td><span>{{ user.email }}</span></td>
                </tr>
                <tr>
                    <td>Subscription status</td>
                    <td>{{ user.subscription_status }}</td>
                </tr>
                <tr v-if="have_referral_code">
                    <td>Referral code</td>
                    <td>

                      <div class="mt050 mb050">
                            <strong class="registration-code mr100">{{ user.referral_code }}</strong>
                            <small>Give your unique referral code out and earn 100 coins (&pound;2) per month per user! <a href="/account/send-referral-mail">Email this code to a friend</a></small>
                      </div>

                    </td>
                </tr>
                <tr>
                    <td>Preferred warm-up</td>
                    <td>
                        <div class="settings-selector-component">
                            <div class="selector">
                                <select name="preferred-warmup" id="preferred-warmup" @change="callUpdateSetting($event, 'preferred_warmup')">
                                    <option value="joints" :selected="user.settings.preferred_warmup.data === 'joints'">5 MINUTE JOINT WARM-UP</option>
                                    <option value="standard" :selected="user.settings.preferred_warmup.data === 'standard'">5 MINUTE WARM-UP (5 MINS)</option>
                                </select>
                            </div>
                            <span class="processing-feedback" :class="{show: currently_processing.indexOf('enter_league') !== -1}"></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Enter monthly leagues</td>
                    <td>
                        <div class="settings-selector-component">
                            <div class="selector">
                                <select name="enter-league" id="enter-league" @change="callUpdateSetting($event, 'enter_league')">
                                    <option value="0" :selected="!user.settings.enter_league">No</option>
                                    <option value="1" :selected="user.settings.enter_league">Yes</option>
                                </select>
                            </div>
                            <span class="processing-feedback" :class="{show: currently_processing.indexOf('enter_league') !== -1}"></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Receive weekly summary emails</td>
                    <td>
                        <div class="settings-selector-component">
                            <div class="selector">
                                <select name="receive-weekly-summary" id="receive-weekly-summary" @change="callUpdateSetting($event, 'receive_weekly_summary')">
                                    <option value="0" :selected="!user.settings.receive_weekly_summary">No</option>
                                    <option value="1" :selected="user.settings.receive_weekly_summary">Yes</option>
                                </select>
                            </div>
                            <span class="processing-feedback" :class="{show: currently_processing.indexOf('receive_weekly_summary') !== -1}"></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Prefer HLS video</td>
                    <td>
                        <div class="settings-selector-component">
                            <div class="selector">
                                <select name="prefer-hls" id="prefer-hls" @change="callUpdateSetting($event, 'prefer_hls')">
                                    <option value="0" :selected="!user.settings.prefer_hls">No</option>
                                    <option value="1" :selected="user.settings.prefer_hls">Yes</option>
                                </select>
                            </div>
                            <span class="processing-feedback" :class="{show: currently_processing.indexOf('prefer_hls') !== -1}"></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Default removed videos to book routines</td>
                    <td>
                        <div class="settings-selector-component">
                            <div class="selector">
                                <select name="prefer-hls" id="prefer-hls" @change="callUpdateSetting($event, 'default_to_book')">
                                    <option value="0" :selected="!user.settings.default_to_book">No</option>
                                    <option value="1" :selected="user.settings.default_to_book">Yes</option>
                                </select>
                            </div>
                            <span class="processing-feedback" :class="{show: currently_processing.indexOf('default_to_book') !== -1}"></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Timezone</td>
                    <td>
                        <div class="settings-selector-component">
                            <div class="selector">
                                <select name="timezone" id="timezone" @change="updateTimezone">
                                    <option v-for="tz in tzoplst" :value="tz.value" :selected="tz.selected">{{ tz.value }}</option>
                                </select>
                            </div>
                            <div class="checker">
                                <label for="auto-adjust-timezone">Auto adjust?</label>
                                <input type="checkbox" id="auto-adjust-timezone" name="auto-adjust-timezone" :checked="user.settings.auto_adjust_timezone" @change="updateTimezone">
                                <span id="jqclock">
                                    12:00
                                </span>
                            </div>
                            <span class="processing-feedback" :class="{show: selectors_processing_status.timezone}"></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Current cycle</td>
                    <td>
                        <div class="settings-selector-component">
                            <div class="selector">
                                <select class="account-settings-select-btn" v-model="selected_day" @change="changeDay">
                                    <option v-for="day in days" :value="day.value">
                                    {{ day.text }}
                                    </option>
                                </select>
                            </div>
                            <span class="processing-feedback" :class="{show: selectors_processing_status.drill_day}"></span>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

    </div>

</template>

<script>

export default {
	props: [
	    'user',
        'usercoins',
        'tzoplst'
    ],
    computed: {
        have_referral_code(){
            return this.user.referral_code !== null && this.user.referral_code.trim() !== '';
        },
    },
	data(){
		return {
            avatar_key: null,
            days: [],
            selected_day: null,
            selectors_processing_status: {
            	league: false,
                timezone: false,
                drill_day: false,
                remove_avatar: false,
                prefer_hls: false
            },
            currently_processing: []
        }
    },
    mounted()
    {
        this.selected_day = this.user.current_day;

        let i = 1;
        while(i <= 7){
        	this.days.push({
                value: i,
                text: i
            });
        	i++;
        }

        this.avatar_key = this.user.avatar;
        this.initJqclock(this.user.local_time_stamp);
    },
    methods: {
		initJqclock(customtimestamp)
        {
        	$("#jqclock").clock('destroy');
            $("#jqclock").clock({
                "calendar": true,
                "dateFormat": "d/m/y, ",
                "timeFormat": "g:iA",
                "langSet":"en",
                "timestamp":customtimestamp
            });
        },
		newAvatarUploaded(avatar_key)
        {
            this.avatar_key = avatar_key;
        },
        removeAvatar()
        {
            this.selectors_processing_status.remove_avatar = true;

			const avatar_key = this.avatar_key;
            // const time = Date().toString();
            //
            axios.post('/api/user/delete-profile-image', { avatar_key: avatar_key }).then((response)=>{

            	this.selectors_processing_status.remove_avatar = false;
                this.avatar_key = null;
            }).catch((e) => {
                if(e.response){
                    console.log(e.response.data.message);
                }else {
                    throw new Error('An error occurred connecting with the server.');
                }
            });
        },


        callUpdateSetting(event, setting_slug)
        {
        	this.currently_processing.push(setting_slug);

        	// assume it's a boolean, as most are, first
	        const value       = event.target.value;
	        let boolean_value = event.target.value;
	        let packet_data   = {'setting_slug': setting_slug, boolean_value: boolean_value};

	        // maybe it isn't tho?
            const is_boolean = !isNaN(value) && (parseInt(value) === 1 || parseInt(value) === 0);

            // if not, replace boolean_value with data_value!
        	if(!is_boolean)
            {
        		delete packet_data.boolean_value;
        		packet_data.data_value = value;
            }

            this.updateUserSetting(packet_data).then(() => {
                const index = this.currently_processing.indexOf(setting_slug);
                if (index > -1) {
                    this.currently_processing.splice(index, 1);
                }
            })
        },
        updateTimezone(event)
        {
        	const timezone = $('#timezone').val();
        	const auto_adjust_timezone = $('#auto-adjust-timezone').is(':checked');

			this.selectors_processing_status.timezone = true;

            axios.post('/api/user/update-timezone', { timezone: timezone, auto_adjust_timezone: auto_adjust_timezone }).then((response)=>{

            	this.selectors_processing_status.timezone = false;

            	this.initJqclock(response.data.local_time_stamp);

            }).catch((e) => {
                if(e.response){
                    console.log(e.response.data.message);
                }else {
                    throw new Error('An error occurred connecting with the server.');
                }
            });
        },
		changeDay(event)
        {
        	this.selectors_processing_status.drill_day = true;

			const new_day = event.target.value;
            // const time = Date().toString();
            //
            axios.post('/api/user/change-day', { new_day: new_day }).then((response)=>{

            	this.selectors_processing_status.drill_day = false;

            }).catch((e) => {
                if(e.response){
                    console.log(e.response.data.message);
                }else {
                    throw new Error('An error occurred connecting with the server.');
                }
            });
        }
    }
}

</script>

































